import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NetworkStats } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    url = environment.api;

    constructor(private readonly _http: HttpClient) {}

    getNetworkStats(): Promise<NetworkStats> {
        return this._http.get<NetworkStats>(`${this.url}/stats`).toPromise();
    }
}
